import { createApiError, API_ERRORS } from './apiError.js';

const STATUS_VALUES = ['pending', 'in-progress', 'completed'];
const PRIORITY_VALUES = ['low', 'medium', 'high'];
const VISIBILITY_VALUES = ['public', 'private'];
const DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;

export const validateTitle = (title) => {
  if (!title || !String(title).trim()) {
    return createApiError(API_ERRORS.VALIDATION_ERROR, 'Başlık boş olamaz', { field: 'title' });
  }
  if (String(title).length > 200) {
    return createApiError(API_ERRORS.VALIDATION_ERROR, 'Başlık en fazla 200 karakter olabilir', { field: 'title' });
  }
  return null;
};

export const validateStatus = (status) => {
  if (!STATUS_VALUES.includes(status)) {
    return createApiError(API_ERRORS.VALIDATION_ERROR, 'Geçersiz durum değeri', { field: 'status' });
  }
  return null;
};

export const validatePriority = (priority) => {
  if (!PRIORITY_VALUES.includes(priority)) {
    return createApiError(API_ERRORS.VALIDATION_ERROR, 'Geçersiz öncelik değeri', { field: 'priority' });
  }
  return null;
};

export const validateDueDate = (dueDate) => {
  if (!dueDate) return null;
  if (!DATE_REGEX.test(dueDate)) {
    return createApiError(API_ERRORS.VALIDATION_ERROR, 'due_date YYYY-MM-DD formatında olmalı', { field: 'due_date' });
  }
  return null;
};

export const validateVisibility = (visibility) => {
  if (!VISIBILITY_VALUES.includes(visibility)) {
    return createApiError(API_ERRORS.VALIDATION_ERROR, 'Geçersiz görünürlük değeri', { field: 'visibility' });
  }
  return null;
};

export const validateTags = (tags) => {
  if (!tags) return null;
  if (!Array.isArray(tags)) {
    return createApiError(API_ERRORS.VALIDATION_ERROR, 'tags bir dizi olmalı', { field: 'tags' });
  }
  if (tags.length > 20) {
    return createApiError(API_ERRORS.VALIDATION_ERROR, 'En fazla 20 etiket eklenebilir', { field: 'tags' });
  }
  for (const tag of tags) {
    if (String(tag).length > 50) {
      return createApiError(API_ERRORS.VALIDATION_ERROR, 'Her etiket en fazla 50 karakter olabilir', { field: 'tags' });
    }
  }
  return null;
};

export const validateChecklist = (checklist) => {
  if (!checklist) return null;
  if (!Array.isArray(checklist)) {
    return createApiError(API_ERRORS.VALIDATION_ERROR, 'checklist bir dizi olmalı', { field: 'checklist' });
  }
  if (checklist.length > 50) {
    return createApiError(API_ERRORS.CHECKLIST_LIMIT_EXCEEDED, 'En fazla 50 kök madde eklenebilir');
  }
  for (const item of checklist) {
    if ((item.children || []).length > 30) {
      return createApiError(API_ERRORS.CHECKLIST_LIMIT_EXCEEDED, 'Her madde için en fazla 30 alt madde eklenebilir');
    }
  }
  return null;
};

export const validateTaskCreate = (payload = {}) => {
  const checks = [
    validateTitle(payload.title),
    validateStatus(payload.status),
    validatePriority(payload.priority),
    validateDueDate(payload.due_date),
    validateVisibility(payload.visibility || 'private'),
    validateTags(payload.tags),
    validateChecklist(payload.checklist),
  ];
  return checks.find((e) => e) || null;
};

export const validateDescription = (description) => {
  if (description && String(description).length > 5000) {
    return createApiError(API_ERRORS.VALIDATION_ERROR, 'Açıklama en fazla 5000 karakter olabilir', { field: 'description' });
  }
  return null;
};
